import type { SlideProps } from "@/engine/app/offsite-config";

const TILES = [
  {
    eyebrow: "Erlaubt",
    title: "Spielwiese — Privat experimentieren",
    text: "Erdrotation, Rezeptideen, Urlaubsplanung – alles erlaubt.",
  },
  {
    eyebrow: "Nur mit Freigabe",
    title: "Firmenkontext — Nur mit Freigabe",
    text: "Kundendaten, Systeme, Prozesse – nur mit Freigabe und in geschützter Umgebung.",
  },
];

export function Slide07Governance(_: SlideProps) {
  return (
    <div className="deck-root dark" style={{ background: "var(--svo-dunkelblau)" }}>
      <div className="deck-bg" aria-hidden="true" />

      <header className="deck-head">
        <div className="deck-eyebrow rise rise-1">Governance</div>
        <h1 className="deck-title rise rise-2">
          Aber: Spielwiese{" "}
          <span className="accent">≠ Firmenkontext</span>
        </h1>
        <p className="deck-sub rise rise-3">
          Gleiche Technologie, verschiedene Spielregeln.
        </p>
      </header>

      <div className="deck-cols2">
        {TILES.map((t, i) => (
          <div key={t.title} className={`col-card rise rise-${i + 4}`}>
            <div className="col-eyebrow">{t.eyebrow}</div>
            <h4>{t.title}</h4>
            <p>{t.text}</p>
          </div>
        ))}
      </div>

      <footer className="deck-foot">
        <span>Claude Enterprise</span>
        <span>KI nutzen – sicher, geprüft, mit Datenschutz-Freigabe.</span>
      </footer>
    </div>
  );
}
